import { createContext } from "react";

const bookingSessionContext = createContext();

export default bookingSessionContext;